<div class="tw-flex tw-items-center tw-gap-[10px] iss-side-nav-menu-item" [class.expanded]="expanded">
  <iss-icon
    class="tw-w-[24px] tw-min-w-[24px] tw-h-[24px] tw-min-h-[24px]"
    [name]="iconName"
    [tuiHint]="(isMobileRes$ | async) ? undefined : title"
  />
  <div class="tw-overflow-hidden tw-overflow-ellipsis tw-whitespace-nowrap">
    {{ title }}
  </div>
</div>
